export default "__VITE_ASSET__Cg05Pq$o__"